const warnSentryDeprecation = () => {
  // eslint-disable-next-line no-console
  console.warn('Deprecation Notice: Sentry Usage is deprecated and removed from SHELL.');
};

function useSentryHelpers() {
  return {
    setScope: warnSentryDeprecation,
    setRelease: warnSentryDeprecation,
    trackError: warnSentryDeprecation,
    reportError: warnSentryDeprecation,
  };
}

export default useSentryHelpers;
